import { Player } from "@lottiefiles/react-lottie-player";
import React from "react";

export default function Services (){
    return (
    <div className="w-[100%] sm:w-[100%] pt-32 sm:pt-65 sm:py-14 mt-2 md:py-16 md:m-0 px-4 md:w-[100%] lg:w-[100%] xl:w-[100%]">
        <div className=" w-[100%] sm:w-[100%] md:w-full lg:w-full xl:w-full mx-auto text-center">
          {/* Our Services Badge */}
          <div className="inline-block mb-6">
            <section id="Services">
            <span className="text-white bg-[#B20925] px-6 py-1 rounded-lg font-roboto">
              Our Services
            </span>
            </section>
          </div>

          {/* Main Headings */}
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
              Solution That Drive Growth
            </h1>
          </div>

          {/* Description Text */}
          <div className="text-gray-600 text-lg leading-relaxed space-y-2">
            <p>
              We combine intelligent engineering, creative design, smart marketing, and <br/> scalable development to empower businesses in the digital-first world
            </p>
            <div className=" w-[100%] sm:w-[100%] md:w-auto lg:w-auto mx-auto">
            <Player
            autoplay
            loop
            src="Services.json"
            className="w-[100%] "
            />
            </div>
          </div>
        </div>
      </div>
      );
}